import { Link } from "react-router-dom";
import { ServiceTitanIconLink } from "@/core/components/service-titan-icon-link";
import { Stack } from "@volca/ui/components/ui/stack";
import { CollapsibleSection } from "./collapsible-section";
import type { ChatMessageSource } from "./types";

export const MessageSources = ({
  sources,
}: {
  sources: ChatMessageSource[];
}) => (
  <CollapsibleSection label={`Sources (${sources.length})`}>
    <Stack align="start" gap={2}>
      {sources.map((source) => (
        <Stack align="start" key={source.key} gap={0}>
          <span className="inline-flex items-center">
            {source.helpPath ? (
              <Link
                to={source.helpPath}
                className="rounded-sm text-xs font-medium text-link underline underline-offset-4 focus-visible:outline-2 focus-visible:outline-focus"
              >
                {source.title}
              </Link>
            ) : (
              <span className="text-xs font-medium text-ink">
                {source.title}
              </span>
            )}
            {source.serviceTitanLink && (
              <ServiceTitanIconLink
                url={source.serviceTitanLink.url}
                label={source.serviceTitanLink.label}
              />
            )}
          </span>
          {source.detail && (
            <p className="text-xs text-subtle">{source.detail}</p>
          )}
        </Stack>
      ))}
    </Stack>
  </CollapsibleSection>
);
